import { html } from 'lit';
import { createElement, SquarePen } from 'lucide';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-pen-square')
export class PdsIconPenSquare extends PdsIcon {
  createIconElement(): SVGElement {
    return createElement(SquarePen);
  }

  render() {
    return html`${this.icon}`;
  }
}
